import type { CapitalGlobalProposalStepProps } from '@/features/proposals/components/capital-global/capital-global-proposal-step.types';
import { CapitalGlobalProposalPaymentFieldsSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-payment-fields-section.component';
import { CapitalGlobalProposalPaymentPremiumSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-payment-premium-section.component';
import { CapitalGlobalProposalStepPagamentoFooter } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-step-pagamento-footer.component';
import { CapitalGlobalProposalStep2FormProvider } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form.context';
import type { CapitalGlobalProposalStep2FormApi } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form.types';
import { useCapitalGlobalProposalStep2ViewModel } from '@/features/proposals/hooks/capital-global/use-capital-global-proposal-step2-view-model.hook';
import { useProposalForm } from '@/features/proposals/hooks/use-proposal-form.hook';
import { capitalGlobalProposalStepPagamentoDefaultValues } from '@/features/proposals/schemas/capital-global/proposal-step-pagamento.schema';

export function StepCapitalGlobalPagamento(
  props: CapitalGlobalProposalStepProps
) {
  const form = useProposalForm({
    defaultValues: capitalGlobalProposalStepPagamentoDefaultValues,
    onSubmit: async () => {},
  }) as unknown as CapitalGlobalProposalStep2FormApi;

  const vm = useCapitalGlobalProposalStep2ViewModel({ ...props, form });

  return (
    <CapitalGlobalProposalStep2FormProvider
      value={{
        form,
        isViewMode: props.isViewMode,
        canGoNext: props.canGoNext,
        canGoBack: props.canGoBack,
        onBack: props.onBack,
        ...vm,
      }}
    >
      <div className='flex flex-col gap-10 [&_label]:font-bold [&_label]:text-alba-black-500'>
        <CapitalGlobalProposalPaymentPremiumSection />
        <CapitalGlobalProposalPaymentFieldsSection />
        <CapitalGlobalProposalStepPagamentoFooter />
      </div>
    </CapitalGlobalProposalStep2FormProvider>
  );
}
